import React, { useMemo, useEffect } from 'react';
import { StylesProvider, ThemeProvider as MuiThemeProvider } from '@material-ui/core';
import { ThemeProvider as SCThemeProvider } from 'styled-components';

import type { AITTheme } from '../theme';
import { createAITTheme } from '../theme';
import { AITThemeContext } from './theme-context';
import { createMuiTheme } from './mui-theme.util';

type Props = {
  theme?: AITTheme;
  children: React.ReactNode;
};
export const AITThemeProvider = ({ theme: rawTheme, children }: Props) => {
  const theme = rawTheme ?? createAITTheme();
  const contextValue = useMemo(() => ({ theme }), [theme]);
  const muiTheme = useMemo(() => createMuiTheme(theme), [theme]);

  // CSS変数（カスタムプロパティ）を:rootに設定。getStyledをscssで使う場合。
  useEffect(() => {
    if (theme.linkColor) {
      document.documentElement.style.setProperty('--link-color', theme.linkColor);
    }
    if (theme.linkColorHover) {
      document.documentElement.style.setProperty('--link-color-hover', theme.linkColorHover);
    }
    if (theme.grayTextColor) {
      document.documentElement.style.setProperty('--gray-text-color', theme.grayTextColor);
    }
  }, [theme.linkColor, theme.linkColorHover, theme.grayTextColor]);

  return (
    <AITThemeContext.Provider value={contextValue}>
      <StylesProvider injectFirst>
        <MuiThemeProvider theme={muiTheme}>
          <SCThemeProvider theme={theme}>{children}</SCThemeProvider>
        </MuiThemeProvider>
      </StylesProvider>
    </AITThemeContext.Provider>
  );
};
